import { tenantApi } from '@shared/api/tenantApi';
import { unwrap, unwrapList } from '@shared/api/unwrap';

/**
 * Products — canonical member-facing routes (`/public/products*`,
 * `publicTenantMiddleware`). Responses use the `{ success, data }` envelope.
 */

export interface ProductSummary {
  product_id: string;
  name: string;
  sku?: string;
  price: number;
  currency: string;
  thumbnail_url?: string;
  category?: string;
  in_stock: boolean;
}

export interface ProductDetail extends ProductSummary {
  description?: string;
  images: Array<{ id: string; url: string }>;
  variants?: Array<{ variant_id: string; label: string; price?: number; in_stock: boolean }>;
}

export interface ProductCategory {
  category_id: string;
  name: string;
}

export async function fetchProducts(query?: {
  search?: string;
  category?: string;
}): Promise<ProductSummary[]> {
  const { data } = await tenantApi.get('/public/products', {
    params: {
      page: 1,
      limit: 60,
      search: query?.search,
      category_id: query?.category,
    },
  });
  return unwrapList<ProductSummary>(data);
}

export async function fetchProductCategories(): Promise<ProductCategory[]> {
  const { data } = await tenantApi.get('/public/products/categories');
  return unwrapList<ProductCategory>(data);
}

export async function fetchProduct(productId: string): Promise<ProductDetail> {
  const { data } = await tenantApi.get(`/public/products/${productId}`);
  return unwrap<ProductDetail>(data);
}
